import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Edit from "./edit";
import Save from "./save";
import transforms from "./transforms";
import "./style.scss";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  transforms,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
      >
        {/* Two pill buttons side by side — the block's whole purpose. */}
        <rect x="1" y="8" width="9.5" height="8" rx="4" />
        <rect
          x="13.5"
          y="8"
          width="9.5"
          height="8"
          rx="4"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
        />
      </svg>
    ),
  },
});
